import {Badge} from '@mui/material'
import styled from 'styled-components'

export const StyledBadgeToBrainBoxAlert = styled(Badge)(({theme}) => ({
  '& .MuiBadge-badge': {
    color: 'red',
    '&::after': {
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '5px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.3)',
      opacity: 0,
    },
  },
}))

export const NoDataBox = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 450;
  padding: 50px 0px;

  @media (max-width: 1540px) {
    font-size: 0.95em;
  }
`

export const ContainerTable = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  flex: 8;
  gap: 16px;
  flex-direction: column;
`

export const ImageRenderResponsive = styled.img<{rowsLenght: number}>`
  object-fit: fill;
  border-radius: 5px;
  cursor: pointer;
  ${({rowsLenght}) =>
    rowsLenght === 1
      ? `min-height: 170px;
          max-height: 170px;`
      : `min-height: 50px;
          max-height: 50px;`}
`
